export const state = () => ({
  snackbar: {
    snackStatus: false,
    snackError: false,
    snackText: '',
    snackColor: '',
    snackLinkName: null,
  },
});
